import { ModalHeader } from '@/components/Modal'
import { ActionBarItem } from '@workwave-tidal/core/components/ActionBar'
import { Close } from '@workwave-tidal/core/icons'

import { useController } from '../hooks/useController'
import { useTexts } from '../useTexts'

function BulkHeader() {
  const texts = useTexts()
  const { close } = useController()

  const title = texts.titleBulk

  return (
    <ModalHeader
      actions={[
        <ActionBarItem
          icon={<Close />}
          key="close"
          testId="close-button"
          onClick={close}
          label=""
        />,
      ]}
      title={title}
    />
  )
}

function SingleHeader() {
  const texts = useTexts()
  const {
    close,
    data: { selectedOrderSteps },
  } = useController()

  const { orderStepType } = selectedOrderSteps.orderSteps[selectedOrderSteps.ids[0]]

  const title = texts.title(orderStepType)

  return (
    <ModalHeader
      title={title}
      actions={[
        <ActionBarItem
          icon={<Close />}
          key="close"
          testId="close-button"
          onClick={close}
          label=""
        />,
      ]}
    />
  )
}

export function InvalidHeader() {
  const texts = useTexts()
  const { close } = useController()

  return (
    <ModalHeader
      title={texts.emptyOrdersTitle}
      actions={[
        <ActionBarItem
          icon={<Close />}
          key="close"
          testId="close-button"
          onClick={close}
          label=""
        />,
      ]}
    />
  )
}

export function Header() {
  const {
    invalid,
    data: { mode },
  } = useController()

  if (invalid) return <InvalidHeader />

  return mode === 'bulk' ? <BulkHeader /> : <SingleHeader />
}
